import { render, staticRenderFns } from "./BlankTextCompletion.vue?vue&type=template&id=0527e7b2&scoped=true&"
import script from "./BlankTextCompletion.vue?vue&type=script&lang=js&"
export * from "./BlankTextCompletion.vue?vue&type=script&lang=js&"
import style0 from "./BlankTextCompletion.vue?vue&type=style&index=0&id=0527e7b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0527e7b2",
  null
  
)

export default component.exports